/* Kiro · Airy Matte story section — v1.0
   Drives every <section class="kiro-story"> on the page. No dependencies, no settings to edit.
   - Finds the site's fixed header / bottom bar by itself and fits the panel between them.
   - Pins with position:sticky, and switches to a transform-based pin on themes where sticky can't work.
   - Swatch starts drawing as the section enters the screen and completes exactly at reason 05;
     the page only moves on after that. */
(function () {
  'use strict';
  if (window.__kiroStoryLoaded) return;
  window.__kiroStoryLoaded = true;

  var NS = 'http://www.w3.org/2000/svg', XLINK = 'http://www.w3.org/1999/xlink';
  var RIM_X = 0.2591;          // bottle opening centre, as a fraction of the product image width
  var FOLLOW_MS = 45;          // how quickly the swatch catches up with the scroll (time constant)
  var TOUCH = /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) ||
    (window.matchMedia && matchMedia('(pointer: coarse)').matches);
  var uid = 0, builds = 0;
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var sm = function (x) { return x * x * (3 - 2 * x); };

  /* ---------- matte mousse swatch (constant thickness, rounded ends) ---------- */
  function el(t, a, p) {
    var e = document.createElementNS(NS, t);
    for (var k in a) e.setAttribute(k, a[k]);
    if (p) p.appendChild(e);
    return e;
  }
  /* The textured paint (lighting, grain, folds) is drawn once into a static image. While scrolling only two dashed strokes
     move: the mask that reveals the paint, and the shadow under it. Re-running the texture filters on every scroll frame is
     what made the swatch lag behind the finger on iPhones. */
  function buildSwatch(svg, d, W, id, grad, c) {
    var key = id + '-' + (++builds);
    var probe = el('path', { d: d }, svg), L = probe.getTotalLength(), n = 220, mid = [];
    for (var i = 0; i <= n; i++) {
      var s = L * i / n, p = probe.getPointAtLength(s);
      var a = probe.getPointAtLength(Math.max(0, s - 1)), b = probe.getPointAtLength(Math.min(L, s + 1));
      var nx = -(b.y - a.y), ny = b.x - a.x, m = Math.hypot(nx, ny) || 1;
      mid.push([p.x, p.y, nx / m, ny / m]);
    }
    // filter / mask area = the swatch itself plus room for its shadow. A huge area (e.g. 3000 x 3000 at 3x on an iPhone)
    // goes past Safari's filter size limit, and Safari then drops the filtered paint entirely (no colour at all).
    var bb = probe.getBBox(), pad = W * 1.5;
    var R = { x: Math.floor(bb.x - pad), y: Math.floor(bb.y - pad), width: Math.ceil(bb.width + pad * 2), height: Math.ceil(bb.height + pad * 2) };
    svg.removeChild(probe);
    var fold = function (k, f0, f1) {
      return 'M' + mid.slice(Math.floor(f0 * n), Math.floor(f1 * n)).map(function (q) {
        return (q[0] + q[2] * W / 2 * k).toFixed(1) + ' ' + (q[1] + q[3] * W / 2 * k).toFixed(1);
      }).join(' L');
    };
    var line = function (extra) {
      var o = { d: d, fill: 'none', 'stroke-linecap': 'round', 'stroke-linejoin': 'round' };
      for (var k in extra) o[k] = extra[k];
      return o;
    };
    var U = { filterUnits: 'userSpaceOnUse', x: R.x, y: R.y, width: R.width, height: R.height };
    var withU = function (o) { for (var k in U) o[k] = U[k]; return o; };
    var MU = { maskUnits: 'userSpaceOnUse', x: R.x, y: R.y, width: R.width, height: R.height };
    var withM = function (o) { for (var k in MU) o[k] = MU[k]; return o; };
    var shade = function (defs, gid) {
      var g = el('linearGradient', { id: gid, gradientUnits: 'userSpaceOnUse', x1: grad[0], y1: grad[1], x2: grad[2], y2: grad[3] }, defs);
      [[0, c.s1], [.4, c.s2], [.75, c.s3], [1, c.s4]].forEach(function (s) { el('stop', { offset: s[0], 'stop-color': s[1] }, g); });
    };

    /* 1) the finished paint, drawn once (filters built element by element so every iOS Safari version parses them) */
    var art = el('svg', { viewBox: R.x + ' ' + R.y + ' ' + R.width + ' ' + R.height, width: R.width, height: R.height });
    var defs = el('defs', {}, art);
    shade(defs, 'shade');
    var mousse = el('filter', withU({ id: 'mousse', 'color-interpolation-filters': 'sRGB' }), defs);
    el('feGaussianBlur', { 'in': 'SourceAlpha', stdDeviation: (W * .075).toFixed(1), result: 'body' }, mousse);
    el('feTurbulence', { type: 'fractalNoise', baseFrequency: '0.85', numOctaves: '4', seed: '9', result: 'air' }, mousse);
    el('feColorMatrix', { 'in': 'air', type: 'matrix', values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0', result: 'airA' }, mousse);
    el('feComposite', { 'in': 'body', in2: 'airA', operator: 'arithmetic', k2: '1', k3: '.16', result: 'height' }, mousse);
    el('feDistantLight', { azimuth: '235', elevation: '52' },
      el('feDiffuseLighting', { 'in': 'height', surfaceScale: '4', diffuseConstant: '1.08', 'lighting-color': '#fff', result: 'diff' }, mousse));
    el('feComposite', { 'in': 'SourceGraphic', in2: 'diff', operator: 'arithmetic', k1: '.5', k2: '.56', result: 'lit' }, mousse);
    el('feComposite', { 'in': 'lit', in2: 'SourceAlpha', operator: 'in' }, mousse);
    el('feGaussianBlur', { stdDeviation: W * .05 }, el('filter', withU({ id: 'soft' }), defs));
    el('feGaussianBlur', { stdDeviation: W * .11 }, el('filter', withU({ id: 'wide' }), defs));
    el('path', line({ stroke: '#fff', 'stroke-width': W }), el('mask', withM({ id: 'shape' }), defs));
    el('path', line({ stroke: 'url(#shade)', 'stroke-width': W }), art);
    el('path', line({ stroke: 'url(#shade)', 'stroke-width': W, filter: 'url(#mousse)' }), art);
    var inner = el('g', { mask: 'url(#shape)' }, art);
    [[.38, 0, .7], [-.3, .25, 1], [.05, .55, 1]].forEach(function (f) {
      el('path', { d: fold(f[0], f[1], f[2]), fill: 'none', stroke: c.foldDark, 'stroke-width': W * .09, 'stroke-linecap': 'round', filter: 'url(#soft)' }, inner);
      el('path', { d: fold(f[0] - .12, f[1], f[2]), fill: 'none', stroke: c.foldLight, 'stroke-width': W * .12, 'stroke-linecap': 'round', filter: 'url(#soft)' }, inner);
    });
    el('path', { d: fold(-.5, 0, 1), fill: 'none', stroke: c.sheen, 'stroke-width': W * .22, 'stroke-linecap': 'round', filter: 'url(#wide)' }, inner);
    el('path', { d: fold(.62, 0, 1), fill: 'none', stroke: c.edge, 'stroke-width': W * .18, 'stroke-linecap': 'round', filter: 'url(#wide)' }, inner);
    var url = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(new XMLSerializer().serializeToString(art));

    /* 2) live layer */
    var group = el('g', {}, svg);
    var live = el('defs', {}, group);
    shade(live, key + '-shade');
    // shadow of the revealed paint only (same two shadows as before, without the paint itself)
    var shadow = el('filter', withU({ id: key + '-shadow' }), live);
    [[W * .13, W * .1, '.16', 'a'], [2, 2, '.12', 'b']].forEach(function (sh) {
      el('feGaussianBlur', { 'in': 'SourceAlpha', stdDeviation: sh[0].toFixed(1) }, shadow);
      el('feOffset', { dy: sh[1].toFixed(1), result: sh[3] + 'o' }, shadow);
      el('feFlood', { 'flood-color': c.shadow, 'flood-opacity': sh[2] }, shadow);
      el('feComposite', { in2: sh[3] + 'o', operator: 'in', result: sh[3] }, shadow);
    });
    var merge = el('feMerge', {}, shadow);
    ['a', 'b'].forEach(function (r) { el('feMergeNode', { 'in': r }, merge); });
    // dashes use the real path length (not pathLength="100", which older Safari ignores for dashes)
    var dash = { 'stroke-dasharray': L.toFixed(1) + ' ' + (L + 10).toFixed(1), 'stroke-dashoffset': L.toFixed(1) };
    var reveal = el('path', line(Object.assign({ stroke: '#fff', 'stroke-width': W + 2 }, dash)), el('mask', withM({ id: key + '-draw' }), live));
    // the revealed part of the paint is exactly this dashed stroke, so its blur is exactly the paint's shadow
    var shadowPath = el('path', line(Object.assign({ stroke: '#000', 'stroke-width': W, filter: 'url(#' + key + '-shadow)' }, dash)), group);
    var shown = el('g', { mask: 'url(#' + key + '-draw)' }, group);
    // plain paint under the image: the image covers it exactly; if a browser can't show the image, the colour still shows
    el('path', line({ stroke: 'url(#' + key + '-shade)', 'stroke-width': W }), shown);
    var im = el('image', { x: R.x, y: R.y, width: R.width, height: R.height, preserveAspectRatio: 'none' });
    im.setAttributeNS(XLINK, 'xlink:href', url);   // older iOS Safari
    im.setAttribute('href', url);
    shown.appendChild(im);
    return { g: group, im: im, dash: [reveal, shadowPath], len: L };
  }

  /* ---------- swatch colours: read from kiro-story.css (--ks-swatch-*) ---------- */
  function swatchColors(root) {
    var cs = getComputedStyle(root), v = function (name) { return cs.getPropertyValue(name).trim(); };
    return {
      s1: v('--ks-swatch-1'), s2: v('--ks-swatch-2'), s3: v('--ks-swatch-3'), s4: v('--ks-swatch-4'),
      shadow: v('--ks-swatch-shadow'), foldDark: v('--ks-swatch-fold-dark'), foldLight: v('--ks-swatch-fold-light'),
      sheen: v('--ks-swatch-sheen'), edge: v('--ks-swatch-edge')
    };
  }

  /* ---------- page edges: fixed headers on top, fixed buy bars at the bottom ---------- */
  function fixedAncestor(e, self) {
    while (e && e !== document.body && e !== document.documentElement) {
      if (self.contains(e)) return null;
      var p = getComputedStyle(e).position;
      if (p === 'fixed' || p === 'sticky') return e;
      e = e.parentElement;
    }
    return null;
  }
  function edges(self) {
    var vw = innerWidth, vh = innerHeight, top = 0, bottom = 0;
    [vw * .5, 12, vw - 12].forEach(function (x) {
      (document.elementsFromPoint(x, 2) || []).forEach(function (e) {
        var f = fixedAncestor(e, self); if (!f) return;
        var r = f.getBoundingClientRect();
        if (r.top <= 4 && r.height < vh * .4) top = Math.max(top, r.bottom);
      });
      (document.elementsFromPoint(x, vh - 2) || []).forEach(function (e) {
        var f = fixedAncestor(e, self); if (!f) return;
        var r = f.getBoundingClientRect();
        if (r.bottom >= vh - 4 && r.height < vh * .35) bottom = Math.max(bottom, vh - r.top);
      });
    });
    return { top: Math.round(top), bottom: Math.round(bottom) };
  }
  function stickyBroken(root) {
    var e = root.parentElement;
    while (e && e !== document.body && e !== document.documentElement) {
      var c = getComputedStyle(e);
      if (/(hidden|auto|scroll)/.test(c.overflowY + ' ' + c.overflowX)) return true;
      e = e.parentElement;
    }
    return false;
  }

  /* ---------- one section ---------- */
  function init(root) {
    if (root.__ks) return;
    root.__ks = true;
    var id = 'kiro-story-' + (++uid);
    var pin = root.querySelector('.ks-pin'), art = root.querySelector('.ks-art'), img = art.querySelector('img');
    var copy = root.querySelector('.ks-copy'), list = root.querySelector('.ks-reasons');
    var items = [].slice.call(root.querySelectorAll('.ks-reason'));
    var N = items.length;
    var nav = root.querySelector('.ks-nav');
    if (!pin || !art || !img || N < 2) return;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

    // swatch layer + nav buttons
    var svg = el('svg', { 'class': 'ks-swatch', 'aria-hidden': 'true', focusable: 'false' });
    pin.insertBefore(svg, pin.firstChild);
    nav.innerHTML = '';
    var btns = items.map(function (it, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = (i < 9 ? '0' : '') + (i + 1);
      b.setAttribute('aria-label', 'Show reason ' + (i + 1) + ': ' + (it.querySelector('h3') || {}).textContent);
      b.addEventListener('click', function () {
        var y = root.getBoundingClientRect().top + pageYOffset - edge.top + (i / (N - 1)) * runway + 2;
        window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
      });
      nav.appendChild(b);
      return b;
    });
    root.classList.add('is-live');
    var transformPin = stickyBroken(root);
    if (transformPin) root.classList.add('ks-transform-pin');

    var edge = { top: 0, bottom: 0 }, runway = 600, swatch = null, shown = 0, visible = true, raf = 0, lastEdge = 0, lastT = 0;
    var drawn = { p: -1, shown: -1, active: -1 };
    var SW = 50;

    function layout() {
      edge = edges(root);
      var vh = innerHeight;
      // reasons block height = tallest reason
      var hMax = 0;
      items.forEach(function (it) { hMax = Math.max(hMax, it.offsetHeight); });
      root.style.setProperty('--ks-reasons-h', hMax + 'px');
      // product height that keeps product + copy + nav on screen between header and buy bar
      var avail = vh - edge.top - edge.bottom;
      var textH = copy.offsetHeight;
      var cs = getComputedStyle(pin);
      var chrome = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom) + parseFloat(cs.rowGap || cs.gap || 18);
      var prodH = clamp(Math.min(avail * .36, 340), 120, Math.max(120, avail - textH - chrome - 30));
      root.style.setProperty('--ks-prod-h', Math.round(prodH) + 'px');
      // room above the bottle for the swatch's rounded head
      SW = clamp(art.getBoundingClientRect().width * .5, 30, 120);
      pin.style.paddingTop = Math.round(Math.max(24, SW * .58)) + 'px';
      // scroll runway: one comfortable flick per reason
      runway = Math.round(N * clamp(vh * .55, 300, 520));
      root.style.height = (pin.offsetHeight + runway) + 'px';
      if (!transformPin) pin.style.top = edge.top + 'px';
      path();
      frame(true);
    }

    function path() {
      var pr = pin.getBoundingClientRect(), ar = art.getBoundingClientRect(), cr = copy.getBoundingClientRect();
      var lr = list.getBoundingClientRect();
      var W = pr.width, H = pr.height;
      svg.setAttribute('viewBox', '0 0 ' + W.toFixed(1) + ' ' + H.toFixed(1));
      // undo the in-flight lift so the path is anchored to the bottle at rest
      var lift = reduce ? 0 : 1 - shown, s = .94 + .06 * (1 - lift);
      var aw = ar.width / s, ah = ar.height / s;
      var aleft = ar.left + (ar.width - aw) / 2, atop = ar.top - lift * 14 + (ar.height - ah) / 2;
      var hs = items.map(function (it) { return it.querySelector('h3'); }).filter(Boolean);
      var hTop = Math.min.apply(null, hs.map(function (h) { return h.offsetTop; }));
      var hH = Math.max.apply(null, hs.map(function (h) { return h.offsetHeight; }));
      var x0 = aleft - pr.left + aw * RIM_X, y0 = atop - pr.top + SW * .12;       // sits on the bottle rim
      var hMid = lr.top - pr.top + hTop + hH / 2;
      var ye = hMid - SW * .113, xe = cr.left - pr.left + cr.width * .42;         // ends on the heading only
      var A = Math.min(W * .34, aw * .94), pts = [];
      for (var i = 0; i <= 140; i++) {
        var t = i / 140;
        pts.push((x0 + (xe - x0) * t + A * Math.sin(Math.PI * 2 * t) * (1 - .25 * t)).toFixed(1) + ' ' + (y0 + (ye - y0) * t).toFixed(1));
      }
      // drop any half-swapped earlier build, then keep the current swatch on screen until the new one's image is ready
      [].slice.call(svg.childNodes).forEach(function (ch) { if (!swatch || ch !== swatch.g) svg.removeChild(ch); });
      var old = swatch;
      swatch = buildSwatch(svg, 'M' + pts.join(' L'), SW, id, [x0 - A, y0, x0 + A, ye], swatchColors(root));
      drawn.shown = -1;
      if (old) {
        var next = swatch, done = false;
        next.g.setAttribute('visibility', 'hidden');
        var swap = function () {
          if (done) return;
          done = true;
          if (old.g.parentNode) old.g.parentNode.removeChild(old.g);
          next.g.removeAttribute('visibility');
        };
        next.im.addEventListener('load', swap);
        setTimeout(swap, 700);
      }
    }

    function frame(force) {
      var vh = innerHeight, now = performance.now();
      if (now - lastEdge > 400) {           // headers that hide/show on scroll
        lastEdge = now;
        var e2 = edges(root);
        if (e2.top !== edge.top) { edge.top = e2.top; if (!transformPin) pin.style.top = edge.top + 'px'; }
        edge.bottom = e2.bottom;
      }
      var r = root.getBoundingClientRect();
      var p = clamp((edge.top - r.top) / runway, 0, 1);                              // reasons: 0 at pin, 1 at 05
      var q = clamp((vh - r.top) / (vh - (edge.top - runway)), 0, 1);                // swatch: from entering view to 05
      if (transformPin) pin.style.transform = 'translate3d(0,' + clamp(edge.top - r.top, 0, runway).toFixed(1) + 'px,0)';
      // follow the scroll closely, at the same speed at 60 Hz and on 120 Hz (ProMotion) screens
      var dt = lastT ? Math.min(now - lastT, 100) : 16.7;
      lastT = now;
      shown += (q - shown) * (reduce || force || document.hidden ? 1 : 1 - Math.exp(-dt / FOLLOW_MS));
      if (Math.abs(q - shown) < .0004) shown = q;
      // only touch the page when something actually changed
      if (shown !== drawn.shown) {
        drawn.shown = shown;
        if (swatch) {
          var off = (swatch.len * (1 - (reduce ? 1 : shown))).toFixed(2);
          swatch.dash.forEach(function (d) { d.setAttribute('stroke-dashoffset', off); });
        }
        var lift = reduce ? 0 : 1 - shown;
        img.style.setProperty('transform', 'translate3d(0,' + (lift * 14).toFixed(2) + 'px,0) rotate(' + (-lift * 3).toFixed(2) + 'deg) scale(' + (.94 + .06 * (1 - lift)).toFixed(4) + ')', 'important');
      }
      if (p !== drawn.p || force) {
        drawn.p = p;
        // reasons: hold each one, crossfade with a soft focus pull between them
        var raw = p * (N - 1), base = Math.min(Math.floor(raw), N - 2), t = raw - base;
        var pos = base + sm(clamp((t - .3) / .4, 0, 1)), active = Math.round(pos);
        items.forEach(function (it, i) {
          var d = i - pos, o = clamp(1 - Math.abs(d) * 2.2, 0, 1);
          it.style.opacity = o.toFixed(3);
          it.style.transform = reduce ? 'none' : 'translate3d(0,' + (d * 40).toFixed(1) + 'px,0)';
          it.style.filter = reduce || o === 1 || o === 0 ? 'none' : 'blur(' + ((1 - o) * 6).toFixed(2) + 'px)';
        });
        if (active !== drawn.active || force) {
          drawn.active = active;
          items.forEach(function (it, i) {
            it.setAttribute('aria-hidden', i === active ? 'false' : 'true');
            it.style.pointerEvents = i === active ? 'auto' : 'none';
          });
          btns.forEach(function (b, i) { b.setAttribute('aria-current', i === active ? 'true' : 'false'); });
        }
      }
      return Math.abs(q - shown) > .0004;
    }

    function loop() {
      raf = 0;
      var moving = frame(false);
      if (visible || moving) schedule();
      else lastT = 0;
    }
    function schedule() {
      if (raf) return;
      if (document.hidden) lastT = 0;
      raf = document.hidden ? setTimeout(loop, 120) : requestAnimationFrame(loop);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) schedule(); }, { rootMargin: '50% 0px 50% 0px' }).observe(root);
    }
    addEventListener('scroll', schedule, { passive: true });
    var rt, lastW = innerWidth, lastH = innerHeight;
    addEventListener('resize', function () {
      // phones: the browser's address / tool bars sliding in and out only nudge the height. Rebuilding then would change the
      // section height mid-scroll and make the page jump, so only a real change (rotation, split view) rebuilds.
      if (TOUCH && innerWidth === lastW && Math.abs(innerHeight - lastH) < 160) return;
      lastW = innerWidth; lastH = innerHeight;
      clearTimeout(rt); rt = setTimeout(layout, 120);
    });
    document.addEventListener('visibilitychange', schedule);
    var go = function () { layout(); schedule(); };
    if (img.complete) go(); else { img.addEventListener('load', go, { once: true }); go(); }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
    addEventListener('load', layout);
  }

  function start() { [].forEach.call(document.querySelectorAll('.kiro-story'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
